import React, { useState } from 'react';
import { useDistributors } from '../../../providers/DistributorProvider';
import { Dropdown, Form, Message, Input } from 'semantic-ui-react';
import statesAbr from '../../../states';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Distributors';

export const CreateDistributor = () => {
    const { checkAuth, getUserType } = useAuth();
    const location = useLocation();

    const distributorObject = location?.state?.distributor;
    const [errors, setErrors] = useState();
    const [state, setState] = useState(distributorObject?.state);
    const [loading, setLoading] = useState(false);
    const { createDistributor, editDistributor, deleteDistributor } = useDistributors();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    const handleUpdate = e => {
        const name = e.target[0].value;
        const pricingMultiplier = e.target[1].value;
        const address = e.target[2].value;
        const city = e.target[3].value;
        const zip = e.target[5].value;
        const notes = e.target[6].value;

        const zipCodeValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
        if (!zipCodeValid) {
            setErrors(['Invalid zip code']);
            return;
        }

        setLoading(true);
        editDistributor(distributorObject.id, name, notes, address, city, state, zip, pricingMultiplier)
            .then(result => {
                setLoading(false);
                navigate('/distributors');
            })
            .catch(err => {
                setLoading(false);
                if (err?.response?.data?.errors) {
                    setErrors(
                        err.response.data.errors.map(error => {
                            return error.description;
                        })
                    );
                } else {
                    setErrors(['Failed to edit distributor.']);
                }
            });
    };

    const handleSubmit = e => {
        const name = e.target[0].value;
        const pricingMultiplier = e.target[1].value;
        const address = e.target[2].value;
        const city = e.target[3].value;
        const zip = e.target[5].value;
        const notes = e.target[6].value;

        const zipCodeValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
        if (!zipCodeValid) {
            setErrors(['Invalid zip code']);
            return;
        }

        setLoading(true);
        createDistributor(name, notes, address, city, state, zip, pricingMultiplier)
            .then(result => {
                setLoading(false);
                navigate('/distributors');
            })
            .catch(err => {
                setLoading(false);
                if (err?.response?.data?.errors) {
                    setErrors(
                        err.response.data.errors.map(error => {
                            return error.description;
                        })
                    );
                } else {
                    setErrors(['Failed to create a new distributor.']);
                }
            });
    };

    return (
        <div>
            <div className="pageHeader">
                <h1>{distributorObject ? 'Edit' : 'Create'} Distributor</h1>
            </div>
            <Form
                onSubmit={distributorObject ? handleUpdate : handleSubmit}
                error={errors ? true : false}
                style={{ maxWidth: '1000px' }}
            >
                <Form.Group>
                    <Form.Input
                        width={11}
                        defaultValue={distributorObject?.name}
                        label="Distributor Name"
                        required
                    />
                    <Form.Field
                        width={5}
                        defaultValue={distributorObject?.pricingMultiplier}
                        label="Pricing Multiplier"
                        type={'number'}
                        control={Input}
                        min={0.001}
                        max={1}
                        step={0.001}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Input
                        width={16}
                        defaultValue={distributorObject?.address}
                        label="Address"
                        required
                    />
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Input
                        defaultValue={distributorObject?.city}
                        label="City"
                        type="city"
                        required
                    />
                    <Form.Field
                        control={Dropdown}
                        fluid
                        selection
                        search
                        options={statesAbr}
                        label={'State'}
                        defaultValue={distributorObject?.state}
                        onChange={(e, selection) => {
                            setState(selection.value);
                        }}
                        style={{ height: '38px' }}
                    />
                    <Form.Input
                        defaultValue={distributorObject?.zip}
                        label="Zipcode"
                        type="zip"
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.TextArea width={16} defaultValue={distributorObject?.notes} label="Notes" />
                </Form.Group>
                {errors ? (
                    <Form.Group widths={2} style={{ paddingLeft: '8px' }}>
                        <Message error list={errors} />
                    </Form.Group>
                ) : null}
                <Form.Group>
                    <Form.Button size={'large'} loading={loading} color={'blue'}>
                        {distributorObject ? 'Update' : 'Submit'}
                    </Form.Button>
                    <Form.Button
                        size={'large'}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/distributors');
                        }}
                    >
                        Cancel
                    </Form.Button>
                    {
                        distributorObject?.id ? (
                            <Form.Button
                                size={'large'}
                                color={'red'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    deleteDistributor(distributorObject.id).then(() => {
                                        navigate('/distributors');
                                    });
                                }}
                            >
                                Delete
                            </Form.Button>
                        ) : null
                    }
                </Form.Group>
            </Form>
        </div>
    );
};
